<template>
    <div class="withdrawal-content">
        <div class="column first" v-if="isTaxable">
            <div class="notice">
                {{ $t('Direct withdrawal to the user\'s bank account.' )}}
            </div>
            <div class="notice pale">
                {{ $t('Dear Customers, according to OUG 18 of March 15, 2018, as of March 24, 2018, the tax due' +
                    ' for withdrawals from online gaming accounts, amounting to 1% (for amounts up to 66750 RON) of' +
                    ' the withdrawn amount, is also determined is retained at source.') }}
            </div>
            <SubtleLinkExternal :link="staticlink($t('payment-method-online'))">
                {{ $t('details about online withdrawal') | capitalize }}
            </SubtleLinkExternal>
        </div>
        <div class="column-notx" v-if="!isTaxable">
            <div class="notice">
                {{ $t('Direct withdrawal to the user\'s bank account.' )}}
            </div>
            <WithdrawalTypeContainer
                :shops="shops"
                :type="type"
                class="column-notx"
            />
            <SubtleLinkExternal :link="staticlink($t('payment-method-online'))">
                {{ $t('details about online withdrawal') | capitalize }}
            </SubtleLinkExternal>
        </div>
        <WithdrawalTypeContainer
            :shops="shops"
            :type="type"
            class="column"
            v-if="isTaxable"
        />
    </div>
</template>

<script>
    import { WithdrawalType } from '@models/user/enums';
    import { routeNames } from '@app/router';
    import { staticlink } from '@shared/filters';
    import WithdrawalTypeContainer from '../components/WithdrawalTypeContainer.ts';

    export default {
        name: 'OnlineWithdrawal',
        props: {
            shops: {
                type: Array,
                required: false,
                default() {
                    return [];
                }
            },
            isTaxable: {
                type: Boolean,
                required: false,
                default: true,
            }
        },
        created() {
            this.type = WithdrawalType.online;
            this.routeNames = routeNames;
            this.staticlink = staticlink;
        },
        components: {
            WithdrawalTypeContainer: WithdrawalTypeContainer(WithdrawalType.online),
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/userProfile/withdrawal/AccordionItems/OnlineWithdrawal.vue